import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../src/AssetStatusForm.scss'
import AssetTabsMobile from "./AssetTabsMobile";
import LoaderOverlay from "../common/Loader/LoaderOverlay";
import StatusTabletForm from "./AssetStatusForms/Tablet/StatusTabletForm";
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SmallSeparationLine from "../common/SeparationLine/SmallSeparation";
import StatusMobileForm from "./AssetStatusForms/Mobile/StatusMobileForm";
import AlarmsModal from "../common/AlarmsModal/AlarmModal";
import ConfirmationModal from "../common/Modal/ConfirmationModal";

type FieldState = {
    [key: string]: string;
};

const statusScreenPanelintialValue = {
    "last": { "value": "", "unit": "" },
    "state": { "value": "", "unit": "" },
    "timeInState": { "value": "", "unit": "" },
    "reason": { "value": "", "unit": "" },
    "closeTrigger": { "value": "", "unit": "" },
    "openTrigger": { "value": "", "unit": "" },
    "lastFall": { "value": "", "unit": "" },
    "lastArrVelocity": { "value": "", "unit": "" },
    "lastArrTime": { "value": "", "unit": "" },
    "lastSlugVol": { "value": "", "unit": "" },
    "alarms": "",
    "tubing": { "value": "", "unit": "" },
    "casing": { "value": "", "unit": "" },
    "line": { "value": "", "unit": "" },
    "gasRate": { "value": "", "unit": "" },
    "battery": { "value": "", "unit": "" },
    "solar": { "value": "", "unit": "" },
    "version": { "value": "", "unit": "" },
    "aux1": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "aux2": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "aux3": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "mode": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "pfc1": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "pfc2": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "todaysOpens": { "value": "", "unit": "" },
    "todaysArrivals": { "value": "", "unit": "" },
    "hexcode": "",
    "todaysAvgArrival": { "value": "", "unit": "" },
    "totalArrival": { "value": "", "unit": "" },
    "iccid": { "value": "", "unit": "" },
    "unit": { "label": "", "index": "", "value": "", "checked": false, "hexCode": "", "unit": "" },
    "loadFactor": { "value": "", "unit": "" },
    "yesterdayOpens": { "value": "", "unit": "" },
    "yesterdayArrivals": { "value": "", "unit": "" },
    "yesterdaysAvgArrival": { "value": "", "unit": "" },
    "plungerTravelDistance": { "value": "", "unit": "" },
    "signalStrength": { "value": "", "unit": "" },
    "activeCarrier": { "value": "", "unit": "" },
    "powerManagementScheme": { "value": "", "unit": "" },
    "powerMode": { "value": "", "hexCode": "", "unit": "" },
    "catchEnabled": "",
    "releaseEnabled": "",
    "openHoldEnabled": "",
    "closeHoldEnabled": "",
    "wellMethod": { "value": "", "text": "" }
}

type WellStatusDetails = typeof statusScreenPanelintialValue & {
    todayAvgArrivalVelocity?: {
        value: number | null;
        unit: string | null;
    };
};


// Define a type for the field state
interface AssetTabsProps {
    assetName: string,
    assetId: string,
    customerId: string,
    userTimeZone: string,
    handleLogout: () => void,
    setWellVersion: React.Dispatch<React.SetStateAction<string>>,
    setAuxProperties: React.Dispatch<React.SetStateAction<{
        aux1: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        aux2: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        aux3: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        pfc1: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        pfc2: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        mode: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        };
        unit: {
            label: string;
            index: string;
            value: string;
            checked: boolean;
            unit: string;
        }
    }>>,
    setisIntermittentMode: React.Dispatch<React.SetStateAction<boolean>>
    setIsBasicWellMethod: React.Dispatch<React.SetStateAction<boolean>>
}



const AssetStatusMobileForm: React.FC<AssetTabsProps> = ({ assetName, assetId, customerId, userTimeZone, handleLogout, setWellVersion, setAuxProperties, setisIntermittentMode, setIsBasicWellMethod }) => {
    const [tabDivHeight, setTabDivHeight] = useState("900px")
    const [wellStatusDetails, setWellStatusDetailsData] = useState<WellStatusDetails>(statusScreenPanelintialValue);
    const [loading, setLoading] = useState(false);
    const [isSetPointloading, setIsSetPointloading] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false)
    const [isValveControlUser, setIsValveControlUser] = useState(false)
    const [initialFormState, setIntialFormState] = useState({} as { [key: string]: FieldState })
    const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
    const [isExpanded, setIsExpanded] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isValveModalOpen, setIsValveModalOpen] = useState(false);
    const [isOpenValveClick, setIsOpenValveClick] = useState("")
    const [isLatestVersion, setLatestVersion] = useState(false)
    const alarms = wellStatusDetails?.alarms ?? "";

    const alarmList = alarms
        .split(",")
        .map(a => a.trim())
        .filter(Boolean);

    const showClearAlarmsButton =
        alarmList.length > 0 &&
        alarmList.some(a => a.toUpperCase() !== "OK") &&
        isVersionGreaterOrEqual(
            wellStatusDetails?.version?.value ?? "",
            "2.1.42"
        );

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const queryParams = {
        // Add your query parameters here
        wellId: assetId,
        customerId: customerId,
        timeZoneId: userTimeZone
    };
    const queryParamsConfig = {
        // Add your query parameters here
        wellId: assetId,
    };

    // Convert the query parameters to a string
    const queryString = new URLSearchParams(queryParams).toString();
    const queryStringForConfiguration = new URLSearchParams(queryParamsConfig).toString();
    const apiUrl = `${baseUrl}/Wells/GetAllStatusData?${queryString}`;
    const postApiUrl = `${baseUrl}/SetPointsAggregation/AddSetPointsDataByAssetId`;
    const getSetPointConfiguration = `${baseUrl}/SetPointsAggregation/GetAllSetPointsMasterByWellID?${queryStringForConfiguration}`;
    const [isMobile, setIsMobile] = useState(window.innerWidth < 620); // Assuming width less than 768px is considered mobile    

    const { aux1, aux2, aux3, mode, unit, pfc1, pfc2 } = wellStatusDetails;
    const [statusScreenHeight, setStatusScreenHeight] = useState("930px")

    useEffect(() => {

        const properties = [aux1, aux2, aux3, mode, unit].filter(prop => prop && prop?.index !== "");
        setAuxProperties({
            aux1: properties[0] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            aux2: properties[1] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            aux3: properties[2] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            mode: properties[3] || { label: 'Disabled', index: '0', value: '0', checked: false, unit: "" },
            unit: properties[4] || { label: 'Disabled', index: '1', value: 'imperial', checked: false, unit: "" },
            pfc1: properties[5] || { label: 'Disabled', index: '0', value: '', checked: false, unit: "" },
            pfc2: properties[6] || { label: 'Disabled', index: '0', value: '', checked: false, unit: "" }
        });

    }, [aux1, aux2, aux3, mode, unit, pfc1, pfc2]); // dependencies


    const renderProperties = () => {
        const staticProperty = [
            { label: "Tubing", value: wellStatusDetails?.tubing?.value, index: "1", hexCode: "", unit: wellStatusDetails?.tubing?.unit },
            { label: "Casing", value: wellStatusDetails?.casing?.value, index: "1", hexCode: "", unit: wellStatusDetails?.casing?.unit },
            { label: "Line", value: wellStatusDetails?.line?.value, index: "1", hexCode: "", unit: wellStatusDetails?.line?.unit },
            { label: "Load factor", value: wellStatusDetails?.loadFactor?.value, index: "1", hexCode: "", unit: wellStatusDetails?.loadFactor?.unit },
            { label: "Gas Rate  ", value: wellStatusDetails?.gasRate?.value, index: "1", hexCode: "", unit: wellStatusDetails?.gasRate?.unit },
            { label: "Battery", value: wellStatusDetails?.battery?.value, index: "1", hexCode: "", unit: wellStatusDetails?.battery?.unit },
            { label: "Solar", value: wellStatusDetails?.solar?.value, index: "1", hexCode: "", unit: wellStatusDetails?.solar?.unit }
        ];

        const lastProperty = [
            { label: "Power Mgmt", value: wellStatusDetails?.powerManagementScheme?.value, index: "1", hexCode: "", unit: wellStatusDetails?.powerManagementScheme?.unit },
            { label: "Power Mode", value: wellStatusDetails?.powerMode?.value, index: "1", hexCode: wellStatusDetails?.powerMode?.hexCode, unit: wellStatusDetails?.powerMode?.unit },
            { label: "Signal Strength", value: wellStatusDetails?.signalStrength?.value, index: "1", hexCode: "", unit: wellStatusDetails?.signalStrength?.unit },
            { label: "Carrier", value: wellStatusDetails?.activeCarrier?.value, index: "1", hexCode: "", unit: wellStatusDetails?.activeCarrier?.unit },
            { label: "Version", value: wellStatusDetails?.version?.value, index: "1", hexCode: "", unit: wellStatusDetails?.version?.unit }
        ]

        const properties = [
            ...staticProperty,
            mode,
            aux1,
            aux2,
            aux3,
            pfc1,
            pfc2,
            ...lastProperty
        ].filter((prop) => prop && prop?.index !== "0" && prop?.index !== "");

        return properties.map((prop, i) => (
            <div key={i} className="w-full" style={{ paddingRight: "20px" }}>
                <div className="ml-3 mt-2 mb-2">
                    <p className="flex justify-betweent text-md">
                        {`${prop?.label}:`}
                        <label className="label text-md ml-auto" style={{ color: prop?.hexCode, border: prop?.hexCode ? `1px solid ${prop?.hexCode}` : "none", padding: prop?.hexCode ? "1px 4px" : undefined }}>
                            {prop?.value}
                            {prop?.unit && (
                                <span style={{ color: "var(--Primary-Indigo-500, #0094BD)", marginLeft: "12px" }}>
                                    | {prop.unit}
                                </span>
                            )}
                        </label>
                    </p>
                </div>
            </div>
        ));
    };

    const isEmptyObject = (obj) => {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    // Function to display toast message
    const sucessShowToast = () => {
        toast.success('Device command executed succesfully!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "white", // Text color
                background: "green", // Background color for success messages
            }
        });
    }

    // Function to display toast message
    const errorShowToast = () => {
        toast.error('Device command failed!', {
            position: "top-right", // Corrected
            autoClose: 3000,
            style: {
                color: "red", // Set your desired text color for error messages
                background: "#f8d7da", // Set your desired background color for error messages
            }
        });
    }

    // Function to open the modal
    const openModal = () => {
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Function for Cancel button
    const handleCancel = () => {
        closeModal(); // Close modal when cancel is clicked
    };

    const getValveActionMessage = (valveAction: string): string => {
        switch (valveAction) {
            case "OpenValve":
                return "Confirm Valve Open?";
            case "OpenHold":
                return "Confirm Hold Open?";
            case "Catch":
                return "Confirm Catch?";
            case "CloseValve":
                return "Confirm Valve Close?";
            case "CloseHold":
                return "Confirm Hold Close?";
            case "Release":
                return "Confirm Release?";
            case "Alarms":
                return "Clear Active Alarms?";
            default:
                return "";
        }
    };

    const handleValveActionClick = async (action: string, comment?: string) => {
        setIsSetPointloading(true);
        const registerMap: Record<string, number> = {
            OpenValve: 43,
            OpenHold: 202,
            CloseValve: 44,
            CloseHold: 203,
            Catch: 220,
            Release: 221,
            Alarms: 50
        };

        const postBody = {
            registers: [{
                Id: registerMap[action],
                value: action === "Alarms" ? "8" : "1"
            }],
            assetId,
            assetName,
        };

        await saveSetpointsData(postBody);
    };



    const saveSetpointsData = async (queryParams) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // specify content type as JSON if sending JSON data
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`
                // You may need to include additional headers based on your API requirements
            },
            body: JSON.stringify(queryParams) // convert data to JSON string
        };
        try {
            const response = await fetch(postApiUrl, requestOptions);
            if (response.status === 401) {
                handleLogout()
            }
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            setIsSetPointloading(false);
            const data = await response?.json();

            if (data === false) {
                setTimeout(errorShowToast, 1000)
            }
            else {
                setTimeout(sucessShowToast, 1000)

            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    function isVersionGreaterOrEqual(v1: string, v2: string): boolean {
        const toNumbers = (v: string) => v.split(".").map(Number);
        const [a1, b1, c1] = toNumbers(v1);
        const [a2, b2, c2] = toNumbers(v2);

        if (a1 !== a2) return a1 > a2;
        if (b1 !== b2) return b1 > b2;
        return c1 >= c2;
    }

    useEffect(() => {
        let timeoutId;

        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setIsMobile(window.innerWidth < 620); // Update state based on window width
            }, 100); // Adjust the debounce interval as needed
        };
        handleResize(); // Initial call to set initial state
        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Remove event listener on component unmount
        };
    }, [window.innerWidth]); // Empty dependency array to run effect only once


    useEffect(() => {
        const fetchData = async (isFirstTime = false) => {
            const headers = {
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                'Content-Type': 'application/json' // Adjust content type if needed
            };
            try {
                const response = await fetch(apiUrl, { headers });
                if (response.status === 401) {
                    handleLogout();
                }
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setWellStatusDetailsData(data);
                setWellVersion(data?.version);
                setisIntermittentMode(data?.intermittentMode)
                setIsBasicWellMethod(data?.wellMethod?.value === 1 ? true : false)
                if (isVersionGreaterOrEqual(data?.version?.value ?? "0.0.0", "2.1.32")) {
                    setLatestVersion(true);
                } else {
                    setLatestVersion(false);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                if (isFirstTime) {
                    setLoading(false); // Set loading to false whether the fetch was successful or not
                }
            }
        };

        const fetchSetPointsConfiguration = async () => {
            const headers = {
                'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                'Content-Type': 'application/json' // Adjust content type if needed
            };
            try {
                const responseConfiguration = await fetch(getSetPointConfiguration, { headers });
                if (responseConfiguration.status === 401) {
                    handleLogout();
                }
                if (!responseConfiguration.ok) {
                    throw new Error('Network response was not ok');
                }
                const configurationData = await responseConfiguration.json();
                setIntialFormState(configurationData.setpoints);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const initialize = async () => {
            setLoading(true);
            setIsReadOnly(Boolean(localStorage.getItem("jwtUserReadOnly") === "false" ? false : true));
            setIsValveControlUser(Boolean(localStorage.getItem("jwtIsValveControlUser") === "false" ? false : true));
            await fetchSetPointsConfiguration();
            await fetchData(true);
        };

        initialize();

        // Schedule fetchData to run every 5 seconds (5000 milliseconds)
        const intervalId = setInterval(fetchData, 5000);

        // Clean up the interval to avoid memory leaks
        return () => clearInterval(intervalId);
    }, [assetId]);

    const handleOpenValveClick = async () => {
        setIsSetPointloading(true)
        const postBody = { registers: [{ Id: 43, value: "1" }], assetId, assetName }
        await saveSetpointsData(postBody)

    }

    const handleCloseValveClsick = async () => {
        setIsSetPointloading(true)
        const postBody = { registers: [{ Id: 44, value: "1" }], assetId, assetName }
        await saveSetpointsData(postBody)
    }


    
    // if (loading) {
    //     return <Spinner />
    // }

    return (
        <div className="bg-darkcolor-800 content-wrapper mt-5">
            {loading && isEmptyObject(initialFormState) && <LoaderOverlay />} {/* Render LoaderOverlay only when loading state is true */}
            <ToastContainer />
            <div
                onClick={toggleExpand}
                style={{ backgroundColor: "#4A5463", marginLeft: "15px", marginRight: "15px" }}
                className="mx-auto pl-[15px] pr-[15px] flex items-center cursor-pointer p-2"
            >
                <div
                    style={{
                        backgroundColor: "var(--Primary-Indigo-400, #60BFDA)",
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "22px",
                        height: "20px",
                        borderRadius: "10%"
                    }}
                    className="p-2"
                >
                    <FontAwesomeIcon icon={isExpanded ? faMinus : faPlus} />
                </div>
                <span
                    style={{ color: "var(--Primary-Indigo-400, #60BFDA)", marginLeft: "5px" }}
                >
                    Status
                </span>
            </div>
            {isExpanded &&
                <div className="border border-darkcolor-500 ml-[15px] mr-[15px] pb-[15px]" style={{ borderTop: 'none', borderRadius: '0 0 8px 8px' }}>
                    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between">
                        <div className="w-full mx-auto">
                            <div className="mx-auto bg-darkcolor-800" style={{ marginTop: "10px" }}>
                                {isMobile ?
                                    <div>
                                        <StatusMobileForm
                                            isReadOnly={isReadOnly}
                                            isSetPointloading={isSetPointloading}
                                            setIsValveModalOpen={setIsValveModalOpen}
                                            setIsOpenValveClick={setIsOpenValveClick}
                                            wellStatusDetails={wellStatusDetails}
                                            statusScreenHeight={"950px"}
                                            renderProperties={renderProperties}
                                            openModal={openModal}
                                            loading={loading}
                                            isValveControlUser={isValveControlUser}
                                            showclearAlarmsButton={showClearAlarmsButton}
                                        />
                                    </div>

                                    :
                                    <StatusTabletForm
                                        isReadOnly={isReadOnly}
                                        isSetPointloading={isSetPointloading}
                                        setIsValveModalOpen={setIsValveModalOpen}
                                        setIsOpenValveClick={setIsOpenValveClick}
                                        wellStatusDetails={wellStatusDetails}
                                        statusScreenHeight={statusScreenHeight}
                                        renderProperties={renderProperties}
                                        openModal={openModal}
                                        loading={loading}
                                        isValveControlUser={isValveControlUser}
                                        showclearAlarmsButton={showClearAlarmsButton}

                                    />
                                }
                                <div className="p-4 border border-darkcolor-500 bg-darkcolor-600 rounded-lg ml-[15px] mr-[15px] mt-2">
                                    {!isEmptyObject(initialFormState) && <AssetTabsMobile initialFormState={initialFormState} setTabDivHeight={setTabDivHeight} assetId={assetId} assetName={assetName} isReadOnly={isReadOnly} isSetPointLoading={isSetPointloading} setIsSetPointLoading={setIsSetPointloading} handleLogout={handleLogout} userTimeZone={userTimeZone} isLatestVersion={isLatestVersion} isValveControlUser={isValveControlUser} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <AlarmsModal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={`Alarms configuration - ${assetName}`}
                onCancel={handleCancel}
            />
            <ConfirmationModal
                isOpen={isValveModalOpen}
                message={getValveActionMessage(isOpenValveClick)}
                setIsValveModalOpen={() => setIsValveModalOpen(false)}
                showCommentBox={isOpenValveClick === "OpenHold" || isOpenValveClick === "CloseHold"}
                handleOpenValveClick={(comment?: string) => handleValveActionClick(isOpenValveClick, comment)}


            />
            <div className={"mb-[15px]"} />
        </div>

    );
};

export default AssetStatusMobileForm;
